import { all, call } from "redux-saga/effects";
import handleError from "@fas/cpa-state-manager/redux/sagas/handleError";
import getManagerInfoSaga from "@fas/cpa-state-manager/redux/sagas/getManagerInfo";
import getUserInfoSaga from "@fas/cpa-state-manager/redux/sagas/getUserInfo";
import { getManagerInfo, getUserInfo } from "../../services/deprecatedApi";
import watchGetReport from "../../sagas/getReportSaga";

const fetchManagerInfo = getManagerInfoSaga({ fetchMethod: getManagerInfo });
const fetchUserInfo = getUserInfoSaga({ fetchMethod: getUserInfo });

export default function* mainSaga() {
  yield all([
    call(handleError),
    call(fetchUserInfo),
    call(fetchManagerInfo),
    call(watchGetReport),
  ]);
}
